import React, { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom';
import { useFirebase } from 'react-redux-firebase';
import { CHATS, RECOVER_PASSWORD, SIGNUP } from '../constants/routes';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../actions';

function Copyright() {
  return (
    <Typography variant="body2" align="center">
      {'Copyright © '}
      <Link color="inherit" href="#">
        Prestobots
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100dvh',
  },
  image: {
    backgroundImage: 'url(https://source.unsplash.com/random)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  loginContainer: {
    background: theme.palette.black.main,
    color: theme.palette.white.main,
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.default.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  input: {
    color: theme.palette.white.main,
    '-webkit-text-fill-color': theme.palette.white.main,
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 1000px #404040 inset',
      color: theme.palette.white.main,
    },
    '&:-internal-autofill-selected': {
      color: theme.palette.white.main,
    },
  },
  cssLabel: {
    color: '#f8f8f8',
    borderColor: '#f8f8f8',
  },
  cssOutlinedInput: {
    '&$cssFocused $notchedOutline': {
      borderColor: `${theme.palette.primary.main} !important`,
    },
  },

  cssFocused: {},

  notchedOutline: {
    borderWidth: '1px',
    borderColor: 'green !important',
  },
}));

export default function Login() {
  const history = useHistory();
  const location = useLocation();
  const firebase = useFirebase();
  const classes = useStyles();

  const appDispatch = useDispatch();

  const auth = useSelector((state) => state.firebase.auth);
  const { from } = location.state || { from: { pathname: CHATS } };
  // redirect after login once auth data is not empty
  useEffect(() => {
    if (auth && auth.isLoaded && !auth.isEmpty) {
      history.push(CHATS);
    }
  }, [auth, from, history]);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  function handleSubmit(event) {
    event.preventDefault();
    firebase
      .login({
        email,
        password,
      })
      .then(() => {})
      .catch((error) => {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: error.message,
            snackbarSeverity: 'error',
          },
        });
      });
  }

  return (
    <div className="App">
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image} />
        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          className={classes.loginContainer}
        >
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Ingresar
            </Typography>
            <form className={classes.form} noValidate onSubmit={handleSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                inputProps={{
                  className: classes.input,
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.cssLabel,
                    focused: classes.cssFocused,
                  },
                }}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                inputProps={{
                  className: classes.input,
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.cssLabel,
                    focused: classes.cssFocused,
                  },
                }}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Iniciar sesion
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link component={RouterLink} to={RECOVER_PASSWORD} variant="body2">
                    ¿Olvidó la contraseña?
                  </Link>
                </Grid>
                <Grid item>
                  <Link component={RouterLink} to={SIGNUP} variant="body2">
                    No tienes una cuenta? Crea una!
                  </Link>
                </Grid>
              </Grid>
              <Box mt={5}>
                <Copyright />
              </Box>
            </form>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
